import React, { useState, useEffect, useMemo } from "react";
import LoanDataService from "../services/LoanService";
import { useSelector } from 'react-redux';
import BeautifulTable from "../../components/BeautifulTable";
import { fNumber } from "../../utils/formatNumber";
 
const LoanUser = (props) => {
  const [loan, setLoan] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const currentUserId = currentUser?.id;

  useEffect(() => {
    retrieveLoan();
  }, []); // eslint-disable-line

  const retrieveLoan = () => {
    LoanDataService.getAll(currentUserId)
      .then((response) => setLoan(response.data ?? response))
      .catch((e) => console.log(e));
  };

  const columns = useMemo(
    () => [
      { Header: "Date", accessor: "date", Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "") },
      { Header: "Amount", accessor: "amount", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Transaction type", accessor: "creditOrDebit", Cell: ({ value }) => (value === "credit" ? "Approved Loan" : (value === "debit" ? "Loan Repayment" : (value || ""))) },
      { Header: "Tenor", accessor: "tenor", Cell: ({ value, row }) => (row?.original?.creditOrDebit === "credit" ? (value ? `${value} Months` : "—") : "—") },
      { Header: "Description", accessor: "description" },
      { Header: "New Balance", accessor: "newBalance", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Posted Date", accessor: "createdAt", Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "") }
    ],
    []
  );

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <BeautifulTable
          columns={columns}
          data={loan}
          pageSize={10}
          onRowClick={(row) => props.history?.push && props.history.push(`/dashboard/loan/${row.id || row._id}`)}
        />
      </div>
    </div>
  );
};

export default LoanUser;
